import React from 'react';
import {FooterContainer, FooterWrap} from './FooterElements';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备17148257号-1</a>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer